import { ProductCategoryRef } from '../models/product.model';

export interface DisplayCategory {
  root: string | null;
  leaf: string;
}

/**
 * Extrae la categoría madre (raíz del árbol) y la hoja para pintar la
 * cabecera de una columna de comparación: eyebrow arriba (root) y línea
 * principal debajo (leaf). Si la primera categoría del producto no tiene
 * `parent`, devuelve `root: null` y se renderiza solo la hoja.
 */
export function pickDisplayCategory(
  categories: ProductCategoryRef[] | undefined,
): DisplayCategory | null {
  if (!categories?.length) return null;
  const withParent = categories.find((c) => c.parent);
  if (withParent?.parent) {
    let root: ProductCategoryRef = withParent.parent;
    while (root.parent) root = root.parent;
    return { root: root.name, leaf: withParent.name };
  }
  return { root: null, leaf: categories[0].name };
}
